exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-3b59df12] .active-current-row{background-color:var(--tableSelectColor)!important}[data-v-3b59df12] .el-table .cell{white-space:normal!important}[data-v-3b59df12] .is-disconnected{text-decoration:line-through}", ""]);

// exports
